import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoggerService } from '@app/shared/services/logger.service';
import { BannerNotificationsService } from '@app/shared/services/banner-notifications.service';
import { MTX_DRAWER_DATA, MtxDrawerRef } from '@ng-matero/extensions/drawer';
import { ClaimsService } from '@app/shared/services/claims.service';
import { AdminScopes, AdminUser, UserService } from '@app/shared/services/user.service';

@Component({
  standalone: false,
  selector: 'app-claim-note',
  templateUrl: './update-claim-note.component.html',
})
export class UpdateClaimNoteComponent implements OnInit {
  public claim: any;
  public adminUser: AdminUser;
  public form: FormGroup;
  public isLoading: boolean = true;

  protected readonly wysiwygModules: { toolbar: Array<any> } = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike', 'link'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ align: [] }],
      ['clean'], // remove formatting button
    ],
  };

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private logger: LoggerService,
    private bannerNotificationsService: BannerNotificationsService,
    public drawerRef: MtxDrawerRef<UpdateClaimNoteComponent>,
    private claimsService: ClaimsService,
    @Inject(MTX_DRAWER_DATA)
    public data: {
      claim: any;
      adminUser: AdminUser;
    }
  ) {}

  ngOnInit() {
    if (
      this.data &&
      this.data.claim &&
      this.data.adminUser &&
      this.userService.hasAuthScope(this.data.adminUser, [AdminScopes.VIEW_CLAIMS])
    ) {
      this.claim = this.data.claim;
      this.adminUser = this.data.adminUser;
      this.createForm();
    } else {
      this.dismissDrawer();
    }
  }

  public submitForm() {
    const formValues = this.form.value;
    const params = {
      claimId: this.claim.id,
      note: formValues.note,
    };

    this.claimsService.updateClaim(this.claim.id, params).subscribe(
      (res) => {
        this.bannerNotificationsService.success('Note was updated successfully');
        this.logger.log('Update claim success', res);
        this.dismissDrawer(true);
      },
      (err) => {
        this.bannerNotificationsService.error('Updating claim note failed');
        this.logger.error('Update claim error', err);
        this.dismissDrawer(false);
      }
    );
  }

  public dismissDrawer(successful: boolean = false): void {
    this.drawerRef.dismiss(successful);
  }

  private createForm() {
    this.form = this.formBuilder.group({
      note: [this.claim.note || ''],
    });
    this.isLoading = false;
  }
}
